import { eachDayOfInterval, endOfWeek, format, startOfWeek } from 'date-fns';
import React, { useMemo } from 'react';
export function DaysOfWeekHeader({ weekStartsOn }) {
    const days = useMemo(() => {
        const arbitraryDate = new Date();
        return eachDayOfInterval({
            start: startOfWeek(arbitraryDate, { weekStartsOn }),
            end: endOfWeek(arbitraryDate, { weekStartsOn })
        });
    }, [weekStartsOn]);
    return (React.createElement("div", { role: "rowgroup", className: "tw-flex tw-flex-col tw-space-y-2" },
        React.createElement("div", { role: "row", className: "tw-flex tw-space-x-2" }, days.map((day) => (React.createElement("div", { key: format(day, 'EEEEEE'), role: "columnheader", "aria-label": format(day, 'EEEE') },
            React.createElement("div", { className: "tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-text-xs tw-text-disabled" }, format(day, 'EEEEE'))))))));
}
//# sourceMappingURL=DaysOfWeekHeader.js.map